import ListingLenderDisclaimer from '@Components/Shared/FinancialCalculator/ListingLenderDisclaimer';
import { getDistinct, sandhillsRequest } from '@Components/Utilities/SandhillsUtility';
import atoms from '@Components/Utilities/SandhillsAtoms';
import { useRecoilValue } from 'recoil';
import translator from '@Components/Utilities/Translator';

const ListingCalculatorCurrencyLink = (props) => {
    const routes = useRecoilValue(atoms.routes);

    const onClick = (e) => {
        sandhillsRequest({
            url: routes.SaveAction,
            method: 'post',
            data: {
                'email': '',
                'actionName': 'purchaseToday',
                'manufacturers': [props.ManufacturerName],
                'models': [props.Model],
                'listingTypes': props.ListingTypes,
                'categoryIDs': getDistinct([props.CategoryId, props.AltCategoryId]),
                'listingIDs': [props.Id],
                'conditions': [props.Condition]
            },
            errorHandling: {
                useConsole: false,
                useAlert: false
            }
        });

        props.OpenCalculator(e);
    };

    return (
        <>
            {(props.Widgets.ShowFinancialCalculator || props.Widgets.LenderDisclaimer) &&
                <div className={props.Widgets.WidgetClass + (props.Widgets.MonthlyFinanceCurrencyUrl ? ' purchase-today-link' : '')}>
                    {props.Widgets.ShowFinancialCalculator &&
                        <>
                            {props.Widgets.MonthlyFinanceCurrencyUrl && !props.Widgets.ShowLenderWidget ?
                            <a className='fin-calc' target='_blank' onClick={onClick} href={props.Widgets.MonthlyFinanceCurrencyUrl} rel='nofollow' aria-label={props.Widgets.FinanceCalculatorDisplayText + " (" + translator.translate('sandhills.opensinanewtab') + ")"}>
                                {props.Widgets.MonthlyFinanceCurrencyUrl ? (props.Widgets.LenderImageURL && <img src={props.Widgets.LenderImageURL} alt="" aria-hidden='true' />) : <i className='fas fa-calculator' aria-hidden='true'></i>}
                                    <span dangerouslySetInnerHTML={{ __html: props.Widgets.FinanceCalculatorDisplayText }}></span>
                                </a>
                                :
                            <p className='fin-calc' role='button' tabIndex='0' onKeyDown={(e) => { if (e.key === "Enter" || e.key === ' ') { e.preventDefault(); onClick(); }}} onClick={onClick}>
                                    {props.Widgets.MonthlyFinanceCurrencyUrl ? (props.Widgets.LenderImageURL && <img src={props.Widgets.LenderImageURL} alt="" />) : <i className='fas fa-calculator'></i>}
                                    <span dangerouslySetInnerHTML={{ __html: props.Widgets.FinanceCalculatorDisplayText }}></span>
                                </p>
                            }
                        </>
                    }
                    {props.Widgets.LenderDisclaimer && props.Widgets.LenderDisclaimerIcon && props.Widgets.ShowMonthlyFinanceRatesOnListings && !props.Widgets.ShowLenderWidget &&
                        <ListingLenderDisclaimer
                            disclaimerText={props.Widgets.LenderDisclaimer}
                            disclaimerIcon={props.Widgets.LenderDisclaimerIcon}
                        />}
                </div>
            }
        </>
    );
};

export default ListingCalculatorCurrencyLink;